<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="状态：">
            <el-select size="medium" v-model="searchForm.value" placeholder="请选择" clearable>
              <el-option v-for="item in PRODUCT_TYPE_LIST" :key="item.typeId" :label="item.name" :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="doQueryTable()" :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="applicationAll">批量申请</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="50" label="序号"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="供应商SKU" min-width="150"></el-table-column>
          <el-table-column prop="BRAND" label="品牌" min-width="150"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="品名" min-width="150"></el-table-column>
          <el-table-column prop="SPECIFICATION" label="规格" min-width="150"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="150"></el-table-column>
          <el-table-column prop="MATCH_STATUS" label="状态" min-width="100">
            <template slot-scope="scope">
              <el-tag>{{ showStatus[scope.row.MATCH_STATUS] }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="submitPrint(scope.row)">替换</el-button>
              <el-button type="text" size="small" icon="el-icon-view" @click="application(scope.row)">申请</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="替换商品选择" center :visible.sync="oneButVisible" width="600px">
          <el-form size="small" :model="oneForm" ref="oneForm">
            <el-form-item label="请选择替换商品：">
              <el-select v-model="changeForm.LKD_PRODUCT_CODE" style="width: 70%" filterable>
                <el-option v-for="item in changeForm" :key="item.LKD_PRODUCT_CODE" :label="item.PRODUCT_NAME"
                  :value="item.LKD_PRODUCT_CODE"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class=" ">
            <el-button size="small" @click="oneButVisible = false">取 消</el-button>
            <el-button size="small" @click="changeSubmit">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      PRODUCT_TYPE_LIST: [{ typeId: 0, name: '未匹配' }, { typeId: 1, name: '等待匹配' }, { typeId: 2, name: '匹配成功' }],
      showStatus: ['未匹配', '等待匹配', '匹配成功'],
      changeForm: [],
      OLD_PRODUCT_CODE: 0,
      loadSearch: false,
      addFormVisible: false,
      addForm: {
        customer: '',
        project: '',
        dkId: '',
        // SEND_DAY: new Date() + 1,
      },
      oneButVisible: false,
      oneForm: {
        oneCustomer: '',
        SEND_DAY: new Date(),
      },
      formLableWidth: '120px',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,

      tableData: JSON.parse(sessionStorage.getItem('tableData')) ? JSON.parse(sessionStorage.getItem('tableData')) : [],
      searchForm: JSON.parse(sessionStorage.getItem('searchForm')) ? JSON.parse(sessionStorage.getItem('searchForm')) : { DAY_INTERVAL: [] },

    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;

    if (this.ENTRY_SEARCH_DATA_CONDITION.CONDITION) {
      this.searchForm = this.ENTRY_SEARCH_DATA_CONDITION.CONDITION;
      this.currentPage = this.ENTRY_SEARCH_DATA_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.getDate();
    this.queryTable();
    this.changeTable();
    this.spaceDate();
  },
  computed: {
    ENTRY_SEARCH_DATA_CONDITION() {
      return this.$store.state.ENTRY_SEARCH_DATA_CONDITION;
    },
  },
  methods: {
    // 匹配数据初始化
    spaceDate() {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 33,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        GYS_ID: this.$route.params.supplier_id,
      };
      http.post(params).then((result) => {

      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    submitPrint(row) {
      this.oneButVisible = true;
      this.OLD_PRODUCT_CODE = row.PRODUCT_CODE;
    },
    // 替换确认
    changeSubmit() {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 34,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        OLD_PRODUCT_CODE: this.OLD_PRODUCT_CODE,
        STD_PRODUCT_CODE: this.changeForm.LKD_PRODUCT_CODE,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        GYS_ID: this.$route.params.supplier_id,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '替换成功', type: 'success' });
        this.oneButVisible = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    close() {
      this.addFormVisible = false;
      this.addForm = {};
    },
    getDate() {
      const day = new Date();
      day.setTime(day.getTime() + 24 * 60 * 60 * 1000);
      const s = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
      this.addForm.SEND_DAY = s;
    },
    doQueryTable() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 拉取匹配好的标准sku
    changeTable() {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 30,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        PLATFORM_ID: 1,
        PAGE_SIZE: 99999999,
        PAGE_INDEX: this.currentPage - 1,
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.changeForm = result[0].SKU_LIST;
        } else {
          this.changeForm = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 进入页面拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 31,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        GYS_ID: this.$route.params.supplier_id,
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.value) {
        params.MATCH_STATUS = this.searchForm.value;
      }
      if (this.searchForm.value === 0) {
        params.MATCH_STATUS = this.searchForm.value;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].PRODUCT_LIST;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SAVE_QUALIFIC_LIST', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.totalCount = 0;
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
    // -----------------申请
    application(row) {
      const arr = [];
      const obj = {};
      obj.PRODUCT_CODE = row.PRODUCT_CODE;
      obj.TYPE_UNIT = row.TYPE_UNIT;
      obj.SPECIFICATION = row.SPECIFICATION;
      obj.PRODUCT_NAME = row.PRODUCT_NAME;
      obj.BRAND = row.BRAND;
      obj.PLATFORM_ID = 1;
      obj.SUPPLIER_NAME = sessionStorage.getItem('company');
      arr.push(obj);
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 32,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SKU_LIST: arr,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '申请成功', type: 'success' });
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    applicationAll() {
      if (this.checkedArray.length !== 0) {
        const params = {
          SERVICE_ID: '10035',
          OTYPE: 32,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SKU_LIST: this.checkedArray,
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '申请成功', type: 'success' });
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请先勾选数据', type: 'warning' });
      }
    },

    handleSelectionChange(val) {
      this.checkedArray = val.map((item) => ({
        PRODUCT_CODE: item.PRODUCT_CODE, TYPE_UNIT: item.TYPE_UNIT, SPECIFICATION: item.SPECIFICATION, PRODUCT_NAME: item.PRODUCT_NAME, BRAND: item.BRAND, PLATFORM_ID: 1, SUPPLIER_NAME: sessionStorage.getItem('company'),
      }));
    },

    chooseDate(e) {
      this.addForm.SEND_DAY = e;
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/marryPageSku.vue